'use client';

import FeatureItem from '@/components/megamenu/FeatureItem';

const products = [
  { text: 'Classic' , href: '/professionals/lifetime-mortgages/classic' },
  { text: 'Sovereign' , href: '/professionals/lifetime-mortgages/sovereign' },
  { text: 'Emerald' , href: '/professionals/lifetime-mortgages/emerald' },
  { text: 'Heritage' , href: '/professionals/lifetime-mortgages/heritage' },
/*  { text: 'Advantage' , href: '/professionals/lifetime-mortgages/advantage' },*/
];

export const MegaMenuLifetimeMortgagesContent = ({ menuItems }) => (
  <>
    <div className="grid grid-cols-5 gap-2">
      <div className="h-[460px] px-10 py-8 bg-[#f3f4f8] col-span-2 pt-14 flex flex-col justify-between lg:pt-8 xl:pt-10">
        <div>
          <p className="mega-menu-featured-content-title mb-4 pt-2">Our products</p>
          <div className="self-stretch h-[244px] flex-col justify-start items-start gap-5 flex">
            {products.map((item, index) => (
              <a href={item.href} key={index} className="self-stretch justify-between items-center inline-flex">
                <div className="grow shrink basis-0 h-6 rounded-lg justify-between items-center flex">
                  <div className="mega-menu-featured-content-product-text hover:text-[#006EB7] cursor-pointer">
                    {item.text}
                  </div>
                  <div className="w-4 h-4 relative">
                    <svg
                      className="icon-on-hover"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                    >
                      <path
                        d="M3.33325 8.93922H12.6666M12.6666 8.93922L7.99992 4.27255M12.6666 8.93922L7.99992 13.6059"
                        stroke="#006EB7"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </a>
            ))}
            <div className="self-stretch justify-start items-center inline-flex">
              <div className="grow shrink basis-0 h-6 rounded-lg justify-start items-center flex">
                <a className="mega-menu-view-all-text cursor-pointer hover:text-[#006EB7]" href="/professionals/lifetime-mortgages">View all</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-[460px] pl-3 pt-8 pb-8 pr-10 py-8 bg-[#fcfcff] col-span-3 lg:pt-1 xl:pt-8">
        <div className="h-[360px] grid grid-cols-2 gap-1">
          {menuItems.map((item, index) => (
            <FeatureItem
              key={index}
              title={item.title}
              description={item.description}
              icon={item.icon}
              href={item.href}
              external={item.external}
            />
          ))}
        </div>
      </div>
    </div>
  </>
);
